import { useMemo } from 'react';
import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
const BASE_URL = 'business-units/v1/business-unit-displays/user/dropdown';
export const GET_BUSINESS_UNITS_NAME = 'businessUnits';
export const GET_BUSINESS_UNITS = registerQuery({
  fieldName: GET_BUSINESS_UNITS_NAME,
  args: [],
  fetcher() {
    return http.get(`${BASE_URL}`);
  }
});
export function useFetchBusinessUnits() {
  const {
    data,
    error,
    loading
  } = useQuery(GET_BUSINESS_UNITS);
  return useMemo(() => ({
    data: data && data[GET_BUSINESS_UNITS_NAME],
    error,
    loading
  }), [data, error, loading]);
}